import {
  TextInput,
  FileInput,
  FileField,
  ArrayInput,
  SimpleFormIterator,
  ReferenceInput,
  SelectInput,
  LongTextInput,
  ImageInput,
  ImageField,
  TabbedForm,
  FormTab
} from "react-admin";
import React from "react";
import QRCode from "qrcode.react";
import { QR_HOST } from "../../configs/index";
import { SUPERADMIN } from "../../constant/TypeRole";
import { required } from "../../services/validate";

// const validateUserCreation = (values) => {
//     const errors = {};
//     const required = ['name', 'type', 'project', 'brochure', 'project_info', 'area_info', 'promotion', 'image']
//     required.forEach((field) => {
//         if (!values[field]) {
//             errors[field] = [`The ${field} is required`];
//         }
//     });
//     return errors
// };

const InterestingForm = props => {
  const {
    redirect,
    record: { _id }
  } = props;

  const role = localStorage.getItem("role");
  const project = JSON.parse(localStorage.getItem("project"));
  const filter = role ? (role === SUPERADMIN ? {} : { _id: project }) : {};
  return (
    <TabbedForm {...props}>
      <FormTab label="interesting.tab.general">
        <ReferenceInput
          validate={[required()]}
          disabled={props.record.project ? true : false}
          source="project"
          reference="project"
          filter={filter}
        >
          <SelectInput optionText="name" />
        </ReferenceInput>
        <TextInput source="name" label="ชื่อภาษาไทย" validate={[required()]} />
        <TextInput source="name_en" label="ชื่อภาษาอังกฤษ" validate={[required()]} />
        <TextInput source="name_jp" label="ชื่อภาษาญี่ปุ่น" validate={[required()]} />
        <TextInput source="name_zh" label="ชื่อภาษาจีน" validate={[required()]} />
        <TextInput validate={[required()]} source="type" />
        <ImageInput
          validate={[required()]}
          multiple={false}
          source="image"
          accept="image/*"
        >
          <ImageField source="url" title="Image" />
        </ImageInput>
      </FormTab>

      <FormTab label="interesting.tab.brochure">
        <FileInput
          validate={[required()]}
          source="brochure"
          accept="application/pdf"
        >
          <FileField target="_blank" source="url" title="brochure" />
        </FileInput>
      </FormTab>

      <FormTab label="interesting.tab.project_info">
        {/* <FileInput
          validate={[required()]}
          source="project_info"
          accept="application/pdf"
        >
          <FileField source="url" title="project info" />
        </FileInput> */}
        <ArrayInput validate={[required()]} source="project_info" fullWidth>
          <SimpleFormIterator>
            <TextInput label="ชื่อไฟล์" validate={[required()]} source="name" />
            <ImageInput
              label="รูปแบนเนอร์"
              validate={[required()]}
              multiple={false}
              source="image"
              accept="image/*"
            >
              <ImageField source="url" title="แบนเนอร์" />
            </ImageInput>
            <FileInput
              label="ไฟล์"
              validate={[required()]}
              source="file"
              accept="application/pdf"
            >
              <FileField target="_blank" source="url" title="ข้อมูลโครงการ" />
            </FileInput>
          </SimpleFormIterator>
        </ArrayInput>
      </FormTab>

      {/* <FormTab label="area info">
                <ArrayInput source="area_info">
                    <SimpleFormIterator>
                        <TextInput label="Area info title" source="title" />
                        <LongTextInput label="Area info description" source="description" />
                        <ImageInput
                            multiple={false}
                            source="image" label="Area info image" accept="image/*">
                            <ImageField source="url" title="Area info image" />
                        </ImageInput>
                    </SimpleFormIterator>
                </ArrayInput>
            </FormTab> */}

      <FormTab label="interesting.tab.promotion">
        <ArrayInput source="promotion" style={{ width: 500 }}>
          <SimpleFormIterator>
            <ImageInput
              validate={[required()]}
              multiple={false}
              source="image"
              label="Promotion"
              accept="image/*"
            >
              <ImageField source="url" title="title" />
            </ImageInput>
            <TextInput
              validate={[required()]}
              multiline
              rows={"5"}
              fullWidth
              label="รายละเอียดภาษาไทย"
              source="description"
            />
            <TextInput
              validate={[required()]}
              multiline
              rows={"5"}
              fullWidth
              label="รายละเอียดภาษาอังกฤษ"
              source="description_en"
            />
            <TextInput
              validate={[required()]}
              multiline
              rows={"5"}
              fullWidth
              label="รายละเอียดภาษาญี่ปุ่น"
              source="description_jp"
            />
            <TextInput
              validate={[required()]}
              multiline
              rows={"5"}
              fullWidth
              label="รายละเอียดภาษาจีน"
              source="description_zh"
            />

            {/* <LongTextInput label="Description" source="description" /> */}
          </SimpleFormIterator>
        </ArrayInput>
      </FormTab>

      {_id &&
        redirect === "list" && (
          <FormTab label="qr">
            <div style={{ margin: "30px 0 30px 30px" }}>
              <QRCode value={`${QR_HOST}?id=${_id}`} />
            </div>
          </FormTab>
        )}
    </TabbedForm>
  );
};

export default InterestingForm;



// WEBPACK FOOTER //
// ./src/components/interesting/InterestingForm.js